/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_SubInputs */

const en_cp_why_sub = /** @type {(inputs: Cp_Why_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programming-education research from 2024–2026 is consistent: AI raises assignment scores but not necessarily understanding. Bystep is built on the side the literature recommends — verification, process assessment, critiquing the AI.`)
};

const id_cp_why_sub = /** @type {(inputs: Cp_Why_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riset pendidikan pemrograman 2024–2026 konsisten: AI menaikkan skor tugas tapi belum tentu pemahaman. Bystep dirancang di sisi yang direkomendasikan literatur — verifikasi, penilaian proses, kritik terhadap AI.`)
};

/**
* | output |
* | --- |
* | "Programming-education research from 2024–2026 is consistent: AI raises assignment scores but not necessarily understanding. Bystep is built on the side the l..." |
*
* @param {Cp_Why_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_sub = /** @type {((inputs?: Cp_Why_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_sub(inputs)
	return en_cp_why_sub(inputs)
});